import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EmployeeDto, EmployeeStatsDto } from '../../../../core/data/new-dtos/employee.dtos';
import { EmployeesService } from '../../services/employees.service';

@Component({
  selector: 'app-employee-stats-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './employee-stats-modal.component.html',
})
export class EmployeeStatsModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() employee!: EmployeeDto;
  @Output() closed = new EventEmitter<void>();

  stats: EmployeeStatsDto | null = null;
  loading = true;
  error: string | null = null;

  constructor(
    private employeesService: EmployeesService,
    private elementRef: ElementRef,
  ) { }

  get roleLabel(): string {
    return (this.employee?.role || '').toLowerCase() === 'manager' ? 'Gerente' : 'Retailer';
  }

  async ngOnInit(): Promise<void> {
    try {
      this.stats = await lastValueFrom(this.employeesService.getStats(this.employee.id));
    } catch (e: any) {
      this.error = e?.error?.error ?? 'No se pudieron cargar las estadísticas.';
    } finally {
      this.loading = false;
    }
  }

  ngAfterViewInit(): void {
    // Escapes any stacking or overflow context the table puts around it
    document.body.appendChild(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    const element = this.elementRef.nativeElement;
    if (element?.parentNode === document.body) {
      document.body.removeChild(element);
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.onClose();
    }
  }

  onClose(): void {
    this.closed.emit();
  }
}
